import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import img_01 from '../../data/images/2.png';
import img_02 from '../../data/images/6.png';

import img_03 from '../../data/icons/notice.png';



type Props = {}

const mock = [
    {
      image: img_01,
      description:(
        <>
            <Typography>
                2024년 상반기 동계 훈련 일정<br />
                <br />
                일시: 2024년 01월 11일 부터 - 01월 31일 까지<br />
                장소: 강원도 태백<br />
                인원: 선수반 전원<br />
                일정: 
            </Typography>
        </>
      ),
        // '2024년 상반기 동계 훈련 일정<br /> 2024-01-11 ~ 01-31',
      title: '[연세 FC 선수반] 동계 훈련 공지',
      author: {
        name: '관리자',
        avatar: 'https://assets.maccarianagency.com/avatars/img4.jpg',
      },
      date: '2023-11-08',
    },
    {
      image: img_02,
      description:
        'test',
      title: '2023 연세 공식 1종 팀, 시즌 종료',
      author: {
        name: '관리자',
        avatar: 'https://assets.maccarianagency.com/avatars/img5.jpg',
      },
      date: '2023-11-08',
    },
  ];


const News = (props: Props) => {
    const navigate = useNavigate();
    const theme = useTheme();

    return (
        <Box sx={{
            width: '100%',
            // border: '1px solid black',
            // padding: '5em'
        }}>
        <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            sx={{
                mt: '10em',
                mb: '5em',
                '@media (max-width: 1300px)': {
                    mt: '0em',
                }
            }}
            // border={'1px solid black'}
        >
            <Typography sx={{ textAlign: 'center' }}>
            <img src={img_03} width={100} />
            </Typography>
            <Typography
                    sx={{
                    textTransform: 'uppercase',
                    fontWeight: '600',
                    }}
                    gutterBottom
                    color={'primary.main'}
                    align={'center'}
                >
                    News & Notice
                </Typography>
                <Typography
                    variant={'h4'}
                    gutterBottom
                    align={'center'}
                    sx={{ 
                        fontWeight: 700,
                        '@media (max-width: 1300px)': {
                            fontSize: '1.5em'
                        } 
                    }}
                >
                    연세 FC News
                </Typography>
                {/* <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => navigate('/photo')}
                    >
                    View all
                </Button> */}
            </Box>
        <Grid container spacing={4} sx={{ '@media (max-width: 1300px)': { p: 0 } }}>
            {mock.map((item, i) => (
            <Grid item xs={12} lg={6} key={i}>
                <Box
                    display={'block'}
                    width={1}
                    height={1}
                    sx={{
                        textDecoration: 'none',
                        transition: 'all .2s ease-in-out',
                        '&:hover': {
                        transform: `translateY(-${theme.spacing(1)})`,
                        },
                    }}
                    >
                <Box
                    component={Card}
                    width={1}
                    height={1}
                    boxShadow={5}
                    display={'flex'}
                    justifyContent={{
                        xs: 'center',
                        md: 'flex-start',
                    }}
                    sx={{
                        borderRadius: '15px',
                        minHeight: 500,
                        backgroundImage: `url("${item.image}")`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        position: 'relative',
                        '&:after': {
                            position: 'absolute',
                            content: '" "',
                            width: '100%',
                            height: '100%',
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0,
                            zIndex: 1,
                            background: '#161c2d',
                            opacity: 0.6,
                        },
                    }}
                >
                    <CardContent
                        sx={{
                            position: 'relative',
                            width: { xs: 1, md: '100%' },
                            height: 1,
                            padding: 5,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            zIndex: 2,
                        }}
                        >
                    <Box>
                        <Typography
                            variant={'h5'}
                            gutterBottom
                            sx={{ color: 'common.white' }}
                        >
                            {item.title}
                        </Typography>
                        <Typography
                            color="text.secondary"
                            sx={{ color: 'common.white', opacity: 0.8, mt: 3 }}
                        >
                            {item.description}
                        </Typography>
                    </Box>
                    <Box>
                        <Divider
                            sx={{
                                marginY: 2,
                                borderColor: 'common.white',
                                opacity: 0.4,
                            }}
                        />
                        <Box
                        display={'flex'}
                        justifyContent={'space-between'}
                        alignItems={'center'}
                        >
                        <Box display={'flex'} alignItems={'center'}>
                            <Avatar
                            component={AccountCircleIcon}
                            sx={{ marginRight: 1 }}
                            />
                            <Typography
                            color={'text.secondary'}
                            sx={{ color: 'common.white', opacity: 0.8 }}
                            >
                            {item.author.name}
                            </Typography>
                        </Box>
                        <Typography
                            color={'text.secondary'}
                            sx={{ color: 'common.white', opacity: 0.8 }}
                        >
                            {item.date}
                        </Typography>
                        </Box>
                    </Box>
                    </CardContent>
                </Box>
                </Box>
            </Grid>
            ))}
        </Grid>
        </Box>
    )
}

export default News